export enum ShiftType {
  MORNING = "Morning Shift",
  AFTERNOON = "Afternoon Shift",
  NIGHT = "Night Shift",
}
export const ShiftAbbreviation: Record<ShiftType, string> = {
  [ShiftType.MORNING]: "MS",
  [ShiftType.AFTERNOON]: "AS",
  [ShiftType.NIGHT]: "NS",
};

export enum DayOfWeek {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}
